import { useEffect } from 'react';

import { HilmaSocket } from '../types';

import useSocket from './useSocket';

const useJoin = (...[name, fn]: Parameters<HilmaSocket['join']>) => {
	const socket = useSocket();

	useEffect(() => {
		socket.join(name, fn);
	}, [name]);
}

export default useJoin;